import AuthPageLayout from './overview/AuthPageLayout';

const AuthLayout = (WrapperContent) => {
  function AuthenticationPage() {
    return (
      <AuthPageLayout>
        <WrapperContent />
      </AuthPageLayout>
    );
  }
  return AuthenticationPage;
};
export default AuthLayout;
